import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LobbyStep, NetworkQuality, RoomAssignment, UserState } from "./types";
import { fetchToken } from "./thunks";
import { TwilioVideoGrantResponse } from "@switcherstudio/switcher-api-client";

export const user = createSlice({
  name: "user",
  initialState: {
    username: "",
    twilioToken: "",
    roomAssignment: undefined,
    lobbyStep: LobbyStep.EnterName,
    isInteracting: false,
    networkQuality: undefined,
    showNetworkQualityHelp: false,
    showAudioTest: false,
    privateChatEnabled: false
  } as UserState,
  reducers: {
    removeToken: (state) => {
      state.twilioToken = "";
    },
    setUsername: (state, { payload }: PayloadAction<string>) => {
      state.username = payload;
    },
    setRoomAssignment: (state, { payload }: PayloadAction<RoomAssignment>) => {
      state.roomAssignment = payload;
    },
    setLobbyStep: (state, { payload }: PayloadAction<LobbyStep>) => {
      state.lobbyStep = payload;
    },
    setIsInteracting: (state, { payload }: PayloadAction<boolean>) => {
      state.isInteracting = payload;
    },
    setNetworkQuality: (state, { payload }: PayloadAction<NetworkQuality>) => {
      state.networkQuality = payload;
    },
    toggleNetworkHelpDialog: (state) => {
      state.showNetworkQualityHelp = !state.showNetworkQualityHelp;
    },
    toggleAudioTestDialog: (state) => {
      state.showAudioTest = !state.showAudioTest;
    }
  },
  extraReducers: {
    [fetchToken.fulfilled.type]: (
      state,
      { payload }: PayloadAction<TwilioVideoGrantResponse>
    ) => {
      state.twilioToken = payload.Token;
      state.privateChatEnabled = payload.EnablePrivateChat && process.env.REACT_APP_TEXT_CHAT_ENABLED === "true";
    },
    [fetchToken.rejected.type]: (_, a) => {
      throw a.error;
    },
  },
});

export const {
  removeToken,
  setUsername,
  setRoomAssignment,
  setLobbyStep,
  setIsInteracting,
  setNetworkQuality,
  toggleNetworkHelpDialog,
  toggleAudioTestDialog
} = user.actions;

export default user.reducer;
